// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see GpsConsentRequestEvent
 */
export var GpsConsentRequest = function (_a) {
    var consentStatus = _a.consentStatus, preciseEnabled = _a.preciseEnabled, eventTrigger = _a.eventTrigger, eventToken = _a.eventToken;
    return ({
        name: "Gps Consent Request",
        parameters: {
            cdf_entity: "Gps",
            cdf_action: "Consent",
            consent_status: consentStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            precise_enabled: preciseEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            event_trigger: eventTrigger !== undefined && eventTrigger !== null ? eventTrigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            event_token: eventToken !== undefined && eventToken !== null ? eventToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GpsCollectDataEventReceivedEvent
 */
export var GpsCollectDataEventReceived = function (_a) {
    var appToken = _a.appToken, eventToken = _a.eventToken;
    return ({
        name: "Gps CollectData EventReceived",
        parameters: {
            cdf_entity: "Gps",
            cdf_action: "CollectData",
            app_token: appToken !== undefined && appToken !== null ? appToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            event_token: eventToken !== undefined && eventToken !== null ? eventToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
